import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer px-9",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Detalle de la cuenta")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nombre del Contacto", -1)
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Email", -1)
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Teléfono Contacto", -1)
const _hoisted_23 = {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip"
}
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-melon-secundario me-2"
}, " Cancelar ", -1)
const _hoisted_29 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton1",
  class: "btn btn-melon px-5"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Guardar Cambios ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espere ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "card mb-5 mb-xl-10" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer px-9",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#card_banco",
  "aria-expanded": "true",
  "aria-controls": "card_banco"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Datos Bancarios")
  ])
], -1)
const _hoisted_35 = {
  id: "card_banco",
  class: "collapse show"
}
const _hoisted_36 = { class: "card-body border-top p-9" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Subir documento banco")
], -1)
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Enviar Documento ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Enviando ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Banco")
], -1)
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Tipo Cuenta")
], -1)
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "Cuenta Vista" }, " Cuenta Vista ", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "Cuenta Corriente" }, " Cuenta Corriente ", -1)
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Número Cuenta")
], -1)
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = {
  type: "submit",
  id: "kt_account_profile_details_submits",
  ref: "submitButtonDatosBancarios",
  class: "btn btn-melon px-5"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Guardar Cambios ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espere ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = { class: "card mb-5 mb-xl-10" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer px-9",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Datos de Acceso y seguridad")
  ])
], -1)
const _hoisted_68 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_69 = { class: "card-body border-top p-9" }
const _hoisted_70 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Contraseña", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, " ************ ", -1)
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Recomendamos contraseñas de 8 digitos con al menos un caracter especial ", -1)
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4" }
const _hoisted_77 = { class: "fv-row mb-0" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", {
  for: "contrasena",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Contraseña Actual", -1)
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "col-lg-4" }
const _hoisted_82 = { class: "fv-row mb-0" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Nueva Contraseña", -1)
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = { class: "col-lg-4" }
const _hoisted_87 = { class: "fv-row mb-0" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmacionNuevaContrasena",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirmar Contraseña", -1)
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "d-flex" }
const _hoisted_92 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Cambiar Contraseña ", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espere... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_95 = [
  _hoisted_93,
  _hoisted_94
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nombres",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "Nombre",
                        modelValue: _ctx.profileDetails.nombres,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileDetails.nombres) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "nombres" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "apellidos",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Apellido",
                        modelValue: _ctx.profileDetails.apellidos,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileDetails.apellidos) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "apellidos" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "email",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Email",
                    modelValue: _ctx.profileDetails.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.email) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("i", _hoisted_23, null, 512), [
                    [_directive_tooltip, 
                                    'A este número nos comunicaremos de ser necesario.'
                                ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "telefono",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Teléfono Contacto",
                    modelValue: _ctx.profileDetails.telefono,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.telefono) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "telefono" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("button", _hoisted_29, _hoisted_32, 512)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("input", {
                class: "form-control",
                type: "file",
                id: "formFile",
                accept: ".pdf",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cargarDocumento && _ctx.cargarDocumento(...args)))
              }, null, 32),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.enviarDocumento && _ctx.enviarDocumento(...args))),
                ref: "submitButtonEnviarDocumentoBanco",
                class: "btn btn-melon px-5 mt-5"
              }, _hoisted_42, 512)
            ])
          ]),
          _createVNode(_component_Form, {
            id: "card_banco_forms",
            class: "form",
            novalidate: "novalidate",
            onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmarSaveDatosBancarios()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    name: "banco",
                    as: "select",
                    modelValue: _ctx.datosProveedor.bancoId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.datosProveedor.bancoId) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bancos, (banco) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: banco.bancoId,
                          key: banco.bancoId
                        }, _toDisplayString(banco.nombreBanco), 9, _hoisted_46))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_ErrorMessage, { name: "banco" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    name: "tipoCuenta",
                    as: "select",
                    modelValue: _ctx.datosProveedor.tipoCuenta,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.datosProveedor.tipoCuenta) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_52,
                      _hoisted_53
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_ErrorMessage, { name: "tipoCuenta" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "numeroCuenta",
                    class: "form-control form-control-lg form-control-solid",
                    modelValue: _ctx.datosProveedor.numeroCuenta,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.datosProveedor.numeroCuenta) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_ErrorMessage, { name: "numeroCuenta" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", _hoisted_62, _hoisted_65, 512)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _hoisted_67,
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, _hoisted_73, 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _hoisted_74,
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updatePassword())),
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "contrasena",
                          id: "contrasena",
                          placeholder: "Contraseña actual",
                          modelValue: _ctx.profileSecurity.contrasena,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.profileSecurity.contrasena) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_ErrorMessage, { name: "contrasena" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "nuevaContrasena",
                          id: "nuevaContrasena",
                          placeholder: "Nueva contraseña",
                          modelValue: 
                                                _ctx.profileSecurity.nuevaContrasena
                                            ,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                                                _ctx.profileSecurity.nuevaContrasena
                                            ) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_ErrorMessage, { name: "nuevaContrasena" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "confirmacionNuevaContrasena",
                          id: "confirmacionNuevaContrasena",
                          placeholder: "Confirme su contraseña",
                          modelValue: 
                                                _ctx.profileSecurity.confirmacionNuevaContrasena
                                            ,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((
                                                _ctx.profileSecurity.confirmacionNuevaContrasena
                                            ) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _createVNode(_component_ErrorMessage, { name: "confirmacionNuevaContrasena" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("button", _hoisted_92, _hoisted_95, 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (
                                        _ctx.passwordFormDisplay =
                                            !_ctx.passwordFormDisplay
                                    )),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, " Cancelar ")
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-melon fw-boldest px-6"
              }, " Generar nueva contraseña ")
            ], 2)
          ])
        ])
      ])
    ])
  ], 64))
}